import axios from 'axios';
import routes from './routes';

export const fetchCidades = estado => (
  axios.get(routes.dadosGerais.fetchCidades(estado))
);



// WEBPACK FOOTER //
// ./src/services/dados-gerais.js